import WidgetSearchClassInformationRequestModel from '../../generated/types/model/resource/WidgetSearchClassInformationRequestModel';

export default class WidgetSearchClassInformationRequestViewModel extends WidgetSearchClassInformationRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
